import React from 'react';
import { Grid } from '@material-ui/core';
import { Field } from 'formik';
import { useStyles } from '../commonStyles';
import i18n from 'i18n-js';
import { CreditTypeSelect } from 'components/AsyncFields';

const CreditTypeInputs = (errors) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} className={classes.container}>
      <Grid container spacing={2}>
        <Grid item xs={6} md={6}>
          <Field
            firstLoad
            margin="none"
            name="invoice_item_type_id"
            id="credit_type_select"
            component={CreditTypeSelect}
            asyncErrors={errors?.invoice_item_type_id}
            label={i18n.t('promo_codes.credit_type')}
            required
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export { CreditTypeInputs };
